<div id="anthem" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">

        <h2 class="title">College Anthem</h2>

        <!-- ── Hidden native audio element (controlled via ViewChild) ── -->
        <audio #audioPlayer
               [src]="audioSrc"
               (loadedmetadata)="onLoadedMetadata()"
               (timeupdate)="onTimeUpdate()"
               (ended)="onEnded()">
        </audio>

        <!-- ── Custom Audio Player Card ─────────────────────────────── -->
        <div class="anthem-player mt-4">

          <!-- Album art / logo side -->
          <div class="player-art">
            <div class="player-waves" [class.playing]="isPlaying">
              <span></span><span></span><span></span><span></span><span></span>
            </div>
          </div>

          <!-- Controls side -->
          <div class="player-body">

            <div class="player-meta">
              <p class="player-title">College Anthem</p>
              <p class="player-subtitle">Shah Satnam Ji Girls' College, Sirsa</p>
            </div>

            <!-- Seek bar -->
            <div class="player-seekbar-row">
              <span class="time-label">{{ currentTimeFormatted }}</span>
              <div class="seekbar-track">
                <div class="seekbar-fill" [style.width.%]="progressPercent"></div>
                <input type="range" class="seekbar-input" min="0" max="100"
                       [value]="progressPercent" (input)="seek($event)">
              </div>
              <span class="time-label">{{ durationFormatted }}</span>
            </div>

            <!-- Buttons -->
            <div class="player-controls">

              <!-- Mute / Volume -->
              <button class="ctrl-btn mute-btn" (click)="toggleMute()" [title]="isMuted ? 'Unmute' : 'Mute'">
                <i class="fa-solid" [ngClass]="isMuted ? 'fa-volume-xmark' : 'fa-volume-high'"></i>
              </button>
              <input type="range" class="volume-slider" min="0" max="100"
                     [value]="volume * 100" (input)="setVolume($event)" title="Volume">

              <div class="play-group">
                <!-- Skip back 10s -->
                <button class="ctrl-btn" (click)="skipBack()" title="Back 10s">
                  <i class="fa-solid fa-backward"></i>
                  <span class="skip-label">10</span>
                </button>

                <!-- Play / Pause -->
                <button class="play-btn" (click)="togglePlay()" [title]="isPlaying ? 'Pause' : 'Play'">
                  <i class="fa-solid" [ngClass]="isPlaying ? 'fa-pause' : 'fa-play'"></i>
                </button>

                <!-- Skip forward 10s -->
                <button class="ctrl-btn" (click)="skipForward()" title="Forward 10s">
                  <i class="fa-solid fa-forward"></i>
                  <span class="skip-label">10</span>
                </button>
              </div>

              <!-- Download -->
              <a [href]="audioSrc" download class="ctrl-btn download-btn" title="Download">
                <i class="fa-solid fa-download"></i>
              </a>

            </div>
          </div>
        </div>
        <!-- ── End Player ─────────────────────────────────────────── -->

        <hr class="divider mt-5">

        <!-- Anthem images -->
        <div class="row g-4 mt-3">
          <div class="col-md-6">
            <img src="assets/img/about/anthem1.jpg"
                 alt="College Anthem - Page 1"
                 class="img-fluid rounded shadow-sm w-100"
                 onerror="this.parentElement.style.display='none'">
          </div>
          <div class="col-md-6">
            <img src="assets/img/about/anthem2.jpg"
                 alt="College Anthem - Page 2"
                 class="img-fluid rounded shadow-sm w-100"
                 onerror="this.parentElement.style.display='none'">
          </div>
          <div class="col-md-6">
            <img src="assets/img/about/anthem3.jpg"
                 alt="College Anthem - Page 3"
                 class="img-fluid rounded shadow-sm w-100"
                 onerror="this.parentElement.style.display='none'">
          </div>
          <div class="col-md-6">
            <img src="assets/img/about/anthem4.jpg"
                 alt="College Anthem - Page 4"
                 class="img-fluid rounded shadow-sm w-100"
                 onerror="this.parentElement.style.display='none'">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
